import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from "@mui/material/Toolbar";
import {Person} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import ConsideringContent from "@/components/admin/ConsideringContent";
import {Divider} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AddBoxIcon from "@mui/icons-material/AddBox";
import {useNavigate} from "react-router-dom";

const Considering = () => {

    const navigate = useNavigate()

    return (
    <>
        <AppBar position="relative" sx={{background:'white', color:'black', boxShadow:'none', borderBottom:'1px solid #e3e3e3'}}>
            <Toolbar>
                <Person sx={{ mr: 2 }} />
                <Typography variant="div" color="inherit" noWrap>
                    Tableau de bord
                </Typography>
                <Divider orientation="vertical" flexItem sx={{margin:2}} />
                <Typography variant="div" color="inherit" noWrap>
                    <IconButton aria-label="delete" size="large" sx={{padding:'5px',borderRadius:'inherit'}}>
                        <AddBoxIcon onClick={() => {navigate('/configurator')} } fontSize="inherit"/>
                    </IconButton>
                </Typography>
            </Toolbar>
        </AppBar>


        <ConsideringContent />


    </>
        );
};

export default Considering;